import React from 'react'
import './FooterComp.css'

const FooterComp = () =>{
    return(
        <section>
            <div className="footer_main_content">
            Giuseppe Tarallo  &copy; all right reserved | London, UK 2023
            </div>
        </section>
    )
}


export default FooterComp;